import script from "./MethArCTBeta.vue?vue&type=script&setup=true&lang=js"
export * from "./MethArCTBeta.vue?vue&type=script&setup=true&lang=js"

import "./MethArCTBeta.vue?vue&type=style&index=0&id=0ef13c89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef13c89"]])

export default __exports__